import "../../App.css";
import React, { lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Route, useNavigate } from "react-router-dom";
import {
  CXOEmpPanelSidebarData,
  CXOPanelSidebarData,
} from "../../Module/CXOPanelSidebarData";
import TeacherLectureFeedback from "./teacherLectureFeedback";
import CxoDashboard from "./cxoDashboard";
import RevenueProjection from "./revenueProjection";
import TechnicalSupportNew from "../TechnicalSupportPanel/technicalSupportNew";
import BatchaAnalisis from "./BatchaAnalisis";
import PayRollCtc from "../SuperAdminPanel/payRollCtc";
import { useSelector } from "react-redux";
import CommonRoutes from "../Common/commonRoute";
import { setInitialState } from "../../Action/authAction";
import { useDispatch } from "react-redux";
import PaymentWiseAnalysis from "./paymentWiseAnalysis";
// import OrderAnalysis from "./orderAnalysis/orderAnalysis";
import UserDataSearch from "./userDataSearch";
import WhatsappMessageAnalysis from "./whatsappmessageAnalysis";
import WhatsappDataAnalysis from "./whatsappDataAnalysis";
import WhatsappDataStateAnalysis from "./whatsappDataStateAnalysis";
import CouponTypeAnalysis from "./couponTypeAnalysis";
import AddOnAnalysis from "./orderAnalysis/addOnAnalysis";
import CrossSellingAnalysis from "./orderAnalysis/crossSellingAnalysis";
import CancelledAnalysis from "./orderAnalysis/cancelledAnalysis";
import PaidAdsAnalysis from "../PaidAdsPanel/paidAdsAnalysis";
import DemoGraphicsData from "./demoGraphicsData";
import FunnelAnalysis from "./funnelAnalysis";
import Chat from "../TeacherPanel/chat";

const RegisteredUser = React.lazy(() => import("./registeredUser"));
const CxoBatchwiseCount = React.lazy(() => import("./cxoBatchWiseCount"));
const DatewiseCount = React.lazy(() => import("./cxoDateWiseCount"));
const RevenueDetails = React.lazy(() => import("../Finance/revenueDetails"));
const StudentCount = React.lazy(() => import("./studentCount"));
const WebsiteLeadCount = React.lazy(() => import("./websiteLeadCount"));
const ReferenceManagerCount = React.lazy(
  () => import("./referenceManagerCount"),
);
const ReferenceTeamLeadCount = React.lazy(
  () => import("./referenceTeamLeadCount"),
);
const ReferenceLeadsCount = React.lazy(() => import("./referenceLeadsCount"));
const TransactionEdutech = React.lazy(() => import("./transactionEdutech"));
const TransactionEdutechOnlineCourse = React.lazy(
  () => import("./transactionEdutechOnlineCourse"),
);
const TransactionEdutechStudyMaterial = React.lazy(
  () => import("./transactionEdutechStudyMaterial"),
);
const AdmissionDetails = React.lazy(
  () => import("../Finance/admissionDetails"),
);
const TransactionPublication = React.lazy(
  () => import("../Finance/transactionPublication"),
);
const ClassroomStudents = React.lazy(() => import("./classroomStudents"));
const TeacherFeedback = React.lazy(() => import("./teacherFeedback"));
const ExpertSupport = React.lazy(() => import("./expertSupport"));
const AssuredRevenue = React.lazy(() => import("../Finance/assuredRevenue"));
const SecondInstallmentPaid = React.lazy(
  () => import("../Finance/secondInstallmentPaid"),
);
const SecondInstallmentDue = React.lazy(
  () => import("../Finance/secondInstallmentDue"),
);
const TeacherRanking = React.lazy(() => import("./teacherRanking"));
const StudentCouponAdd = React.lazy(
  () => import("./studentCouponCode/studentCouponAdd"),
);
const StudentCouponEdit = React.lazy(
  () => import("./studentCouponCode/studentCouponEdit"),
);
const SourceAnalysis = React.lazy(() => import("./sourceWiseAnalysis"));
const StateAnalysis = React.lazy(() => import("./stateWiseAnalysis"));
const LeadOverview = React.lazy(() => import("./leadOverview"));
const DailyMeeting = React.lazy(() => import("./dailyMeeting"));
const TeamLeadAssignedDateAnalysis = React.lazy(
  () => import("./teamLeadAssignedDateAnalysis"),
);
const CounsellorLeadOverview = React.lazy(
  () => import("./counsellorLeadOverview"),
);
const LeadAssignedDateAnalysis = React.lazy(
  () => import("./leadAssignedDateAnalysis"),
);
const LeadAssignedStatusOverview = React.lazy(
  () => import("./leadAssignedStatusOverview"),
);
const CompleteLeadDetail = React.lazy(() => import("./completeLeadDetail"));
const AddWPConfiguration = React.lazy(
  () => import("./whatsappConfiguration/createWPConfiguration"),
);
const EditWPConfiguration = React.lazy(
  () => import("./whatsappConfiguration/editWPConfiguration"),
);
const PaymentPublication = React.lazy(() => import("./paymentPublication"));
const OldPackageExist = React.lazy(() => import("./oldPackageExists"));
const MessageDeliveredStatus = React.lazy(
  () => import("./messageDeliveredStatus"),
);
const TransactionDetails = React.lazy(() => import("./transactionDetails"));
const LeadAnalysis = React.lazy(() => import("./leadAnalysis"));
const CxoPayRoll = React.lazy(() => import("./cxoPayRoll"));
const BdePerformance = React.lazy(() => import("./bdePerformance"));
const CategoryPerformance = React.lazy(() => import("./categoryPerformance"));
const SocialMediaPerformance = React.lazy(
  () => import("./socialMediaPerformance"),
);
const SalesPerformance = React.lazy(() => import("./salesPerformance"));
const OverviewChannel = React.lazy(() => import("./overviewChannel"));
const TeacherPerformance = React.lazy(() => import("./teacherPerformance"));
const AllExamWiseRevenue = React.lazy(() => import("./allExamWiseRevenue"));
const ExamWiseRevenue = React.lazy(() => import("./examWiseRevenue"));
const RegisterCount = React.lazy(() => import("./registerCount"));
const ReferenceGenerated = React.lazy(() => import("./referenceGenerated"));

const BoardMeetingEdutech = React.lazy(() => import("./boardMeetingEdutech"));
const BoardMeetingPublication = React.lazy(
  () => import("./boardMeetingPublication"),
);
const BoardMeetingLeads = React.lazy(() => import("./boardMeetingLeads"));
const TeacherTaskPlanComplete = React.lazy(
  () => import("../DataEntryPanel/teacherTaskPlanComplete"),
);
const TeacherTaskPlanPending = React.lazy(
  () => import("../DataEntryPanel/teacherTaskPlanPending"),
);

const TeacherTaskPlanNotCompleted = React.lazy(
  () => import("../DataEntryPanel/teacherTaskPlanNotCompleted"),
);
const DownloadReports = React.lazy(() => import("./downloadReports"));
const YoutubeTargetPerformance = React.lazy(
  () => import("./youtubeTargetPerformance"),
);
const GetInfluencer = React.lazy(() => import("./influencer/getInfluencer"));
const StudentResult = lazy(() => import("../CategoryPanel/studentResult"));
const EmployeeDetails = lazy(() => import("./employeeDetails"));
const ResultCompilation = lazy(
  () => import("../CategoryPanel/resultCompilation"),
);

const MovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = React.lazy(
  () => import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const ActiveUser = lazy(() => import("./activeUser"));
const InfluencerPayment = lazy(
  () => import("../InfluencerPanel/Payment/InfluencerPaymentCommon"),
);
const ReferralPayment = lazy(() => import("./referralPayment/ReferralPayment"));
const SalesVPDashboard = lazy(() => import("./salesVPDashboard"));
const OrderAnalysis = lazy(() => import("./orderAnalysis/orderAnalysis"));
const UpgradeOrderAnalysis = lazy(
  () => import("./orderAnalysis/upgradeOrderAnalysis"),
);
const ExtendOrderAnalysis = lazy(
  () => import("./orderAnalysis/extendOrderAnalysis"),
);
const StudentExtendExpired = lazy(
  () => import("./orderAnalysis/studentExtendExpired"),
);
const CancelPaymentDone = lazy(
  () => import("./orderAnalysis/cancelPaymentDone"),
);
const UserActivity = lazy(() => import("./orderAnalysis/userActivity"));
const AddToCart = lazy(() => import("./orderAnalysis/addToCart"));
const VideoDownloaded = lazy(() => import("./VideoDownloaded/VideoDownloaded"));
const AllStudentResult = lazy(() => import("./allStudentResult"));
const StudentType2 = lazy(() => import("./orderAnalysis/studentType2"));
const StudentType3 = lazy(() => import("./orderAnalysis/studentType3"));
const SpinTheWheel = lazy(() => import("./orderAnalysis/spinTheWheel"));
const BirthDayList = lazy(() => import("./orderAnalysis/birthDayList"));
const BirthDayAnalysis = lazy(() => import("./orderAnalysis/birthDayAnalysis"));
const SourceWiseDataAnalysis = lazy(
  () => import("./orderAnalysis/sourceWiseDataAnalysis"),
);
const SourceWiseConversionAnalysis = lazy(
  () => import("./orderAnalysis/sourceWiseConversionAnalysis"),
);
const PaidPageAnalysis = lazy(() => import("./paidPageAnalysis"));
const FreePageAnalysis = lazy(() => import("./freePageAnalysis"));
const CategoryWiseAnalysis = lazy(() => import("./categoryWiseAnalysis"));
const StoryAnalysis = lazy(() => import("./storyAnalysis/StoryAnalysis"));
const StudentDetails = lazy(
  () => import("../AcademicHeadPanel/categoryWiseAnalysis/studentDetails"),
);
const SourceWiseLeadAnalysis = lazy(
  () =>
    import("../AcademicHeadPanel/categoryWiseAnalysis/sourceWiseLeadAnalysis"),
);
const UserActivityTracker = lazy(
  () => import("../AcademicHeadPanel/userActivityTracker"),
);
const UserActivityDetails = lazy(
  () => import("../AcademicHeadPanel/userActivityDetails"),
);
const ClassroomRegistrationAnalysis = lazy(
  () => import("./classroomRegistration/classroomRegistrationAnalysis"),
);
const PaymentDone = lazy(() => import("./classroomRegistration/paymentDone"));
const UpcomingPayment = lazy(
  () => import("./classroomRegistration/upcomingPayment"),
);
const EditDeleteCampaign = lazy(
  () => import("../ConfigurationData/Campaign/editDeleteCampaign"),
);
const TeacherWiseAnalysis = lazy(
  () => import("./TeacherAnalysis/TeacherWiseAnalysis"),
);
const EditDeleteEmailCamp = lazy(
  () => import("../ConfigurationData/EmailCampaign/editDeleteEmailCamp"),
);
const RefundPayment = lazy(
  () => import("../Finance/RefundPayment/refundPayment"),
);
const SevenDayFreeTask = lazy(() => import("./orderAnalysis/sevenDayFreeTask"));
const ChatAnalysis = lazy(() => import("./chatAnalysis"));
import OriginalSourceAnalysis from "../PaidAdsPanel/originalSourceAnalysis";
const ExamAnalytics = lazy(() => import("./examAnalytics/examAnalytics"));
const BookSalesAnalysis = lazy(
  () => import("./BookSalesAnalysis/BookSalesAnalysis"),
);
const SubscriptionAnalysis = lazy(
  () => import("./SubscriptionAnalysis/SubscriptionAnalysis"),
);
const CampaignAnalyticsModern = lazy(
  () => import("../MarketingPanel/CampaignAnalytics/CampaignAnalytics"),
);
const OrderBreakdownbySegment = lazy(
  () => import("./orderBreakdown/OrderBreakdownbySegment"),
);
const TargetingExamAnalysis = lazy(
  () => import("./targetingExamAnalysis/targetingExamAnalysis"),
);
const LeadOrderSearch = lazy(
  () => import("../ConfigurationData/leadOrdersSearch"),
);
// Daily Meeting tab
const TeacherPerformanceCat = lazy(
  () => import("../CategoryPanel/teacherPerformanceCategory"),
);
const OffTopicPerformance = lazy(
  () => import("../CategoryPanel/offTopicPerformance"),
);
const EditLiveCompetitorAnalysis = lazy(
  () =>
    import("../CategoryPanel/CompetitorAnalysis/LiveAnalysis/editLiveCompetitorAnalysis"),
);
const EditOffVideoCompetitorAnalysis = lazy(
  () =>
    import("../CategoryPanel/CompetitorAnalysis/OffVideoAnalysis/editOffVideoAnalysis"),
);
const DailyLeadAnalysis = lazy(() => import("../Common/DailyMeeting/dailyLeadAnalysis"));
const InstaReels = lazy(() => import("../Common/DailyMeeting/instaReels"));
const DailyRevenueAnalysis = lazy(
  () => import("../Common/DailyMeeting/dailyRevenueAnalysis"),
);
const UserActivityAnalysis = lazy(
  () => import("../Common/DailyMeeting/userActivityAnalysis"),
);
const DailyPaidAdsAnalysis = lazy(
  () => import("../Common/DailyMeeting/paidAdsAnalysis"),
);

function CXOPanelDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    authToken: state?.Auth?.authToken,
    role: state?.Auth?.userInfo?.role,
  }));

  useEffect(() => {
    if (!(role === "CXO" && authToken)) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, authToken, navigate]);

  return (
    <div className="AppBox">
      <Sidebar
        data={loginType === 2 ? CXOEmpPanelSidebarData : CXOPanelSidebarData}
      />
      <div className="dashboard">
        {
          <CommonRoutes
            loginType={loginType}
            defaultPage={<TransactionDetails />}
          >
            <Route path="registeredUser" element={<RegisteredUser />} />
            <Route path="cxobatchwiseCount" element={<CxoBatchwiseCount />} />
            <Route path="admissionDetails" element={<AdmissionDetails />} />
            <Route path="datewiseCount" element={<DatewiseCount />} />
            <Route path="revenueDetails" element={<RevenueDetails />} />
            <Route path="allSourceLead" element={<StudentCount />} />
            <Route path="websiteLeadCount" element={<WebsiteLeadCount />} />
            <Route
              path="referenceManagerCount"
              element={<ReferenceManagerCount />}
            />
            <Route
              path="referenceTeamLeadCount"
              element={<ReferenceTeamLeadCount />}
            />
            <Route
              path="referenceLeadsCount"
              element={<ReferenceLeadsCount />}
            />
            <Route path="transactionEdutech" element={<TransactionEdutech />} />
            <Route
              path="transactionEdutechOnlineCourse"
              element={<TransactionEdutechOnlineCourse />}
            />
            <Route
              path="transactionEdutechStudyMaterial"
              element={<TransactionEdutechStudyMaterial />}
            />
            <Route path="paymentPublication" element={<PaymentPublication />} />
            <Route
              path="transactionPublication"
              element={<TransactionPublication />}
            />
            <Route path="classroomStudents" element={<ClassroomStudents />} />
            <Route path="teacherFeedback" element={<TeacherFeedback />} />
            <Route path="expertSupport" element={<ExpertSupport />} />
            <Route
              path="teacherLectureFeedback"
              element={<TeacherLectureFeedback />}
            />
            <Route path="assuredRevenue" element={<AssuredRevenue />} />
            <Route
              path="secondInstallmentPaid"
              element={<SecondInstallmentPaid />}
            />
            <Route
              path="secondInstallmentDue"
              element={<SecondInstallmentDue />}
            />
            <Route path="teacherRank" element={<TeacherRanking />} />
            <Route path="studentCouponAdd" element={<StudentCouponAdd />} />
            <Route path="studentCouponEdit" element={<StudentCouponEdit />} />
            <Route path="sourceWiseAnalysis" element={<SourceAnalysis />} />
            <Route path="stateWiseAnalysis" element={<StateAnalysis />} />
            <Route path="leadOverview" element={<LeadOverview />} />
            <Route path="dailyMeeting" element={<DailyMeeting />} />
            <Route
              path="teamLeadAssignedDateAnalysis"
              element={<TeamLeadAssignedDateAnalysis />}
            />
            <Route
              path="counsellorLeadOverview"
              element={<CounsellorLeadOverview />}
            />
            <Route
              path="leadAssignedDateAnalysis"
              element={<LeadAssignedDateAnalysis />}
            />
            <Route
              path="leadAssignedStatusOverview"
              element={<LeadAssignedStatusOverview />}
            />
            <Route path="completeLeadDetail" element={<CompleteLeadDetail />} />
            <Route path="addWPConfig" element={<AddWPConfiguration />} />
            <Route path="editWPConfig" element={<EditWPConfiguration />} />
            <Route path="oldPackageExist" element={<OldPackageExist />} />
            <Route
              path="messageDeliveredStatus"
              element={<MessageDeliveredStatus />}
            />
            <Route path="transactionDetails" element={<TransactionDetails />} />
            <Route path="cxoDashboard" element={<CxoDashboard />} />
            <Route path="RevenueProjection" element={<RevenueProjection />} />
            <Route path="leadAnalysis" element={<LeadAnalysis />} />
            <Route path="cxoPayroll" element={<CxoPayRoll />} />
            <Route path="bdePerformance" element={<BdePerformance />} />
            <Route
              path="categoryPerformance"
              element={<CategoryPerformance />}
            />
            <Route
              path="socialMediaPerformance"
              element={<SocialMediaPerformance />}
            />
            <Route path="salesPerformance" element={<SalesPerformance />} />
            <Route path="overviewChannel" element={<OverviewChannel />} />
            <Route path="teacherPerformance" element={<TeacherPerformance />} />
            <Route path="activeUser" element={<ActiveUser />} />
            <Route path="allExamWiseRevenue" element={<AllExamWiseRevenue />} />
            <Route path="examWiseRevenue" element={<ExamWiseRevenue />} />
            <Route path="registerCount" element={<RegisterCount />} />
            <Route path="referenceGenerated" element={<ReferenceGenerated />} />
            <Route
              path="boardMeetingEdutech"
              element={<BoardMeetingEdutech />}
            />
            <Route
              path="boardMeetingPublication"
              element={<BoardMeetingPublication />}
            />
            <Route path="boardMeetingLeads" element={<BoardMeetingLeads />} />
            <Route
              path="teacherTaskPlanComplete"
              element={<TeacherTaskPlanComplete />}
            />
            <Route
              path="teacherTaskPlanPending"
              element={<TeacherTaskPlanPending />}
            />
            <Route
              path="teacherTaskPlanNotCompleted"
              element={<TeacherTaskPlanNotCompleted />}
            />
            <Route path="downloadReports" element={<DownloadReports />} />
            <Route
              path="youtubeTargetPerformance"
              element={<YoutubeTargetPerformance />}
            />
            <Route path="getInfluencer" element={<GetInfluencer />} />
            <Route path="resultCompilation" element={<ResultCompilation />} />
            <Route path="studentResult" element={<StudentResult />} />
            <Route path="technicalSupport" element={<TechnicalSupportNew />} />
            <Route path="payRollCtc" element={<PayRollCtc />} />
            <Route path="UpcomingBatchAnalysis" element={<BatchaAnalisis />} />
            <Route path="employeeDetails" element={<EmployeeDetails />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route
              path="editMovementsOfMeeting"
              element={<EditMovementsOfMeeting />}
            />
            <Route
              path="influencerPayment"
              element={<InfluencerPayment type={2} />}
            />
            <Route path="referralPayment" element={<ReferralPayment />} />
            <Route path="salesVPDashboard" element={<SalesVPDashboard />} />

            <Route
              path="paymentWiseAnalysis"
              element={<PaymentWiseAnalysis />}
            />
            <Route path="orderAnalysis" element={<OrderAnalysis />} />
            <Route
              path="upgradeOrderAnalysis"
              element={<UpgradeOrderAnalysis />}
            />
            <Route
              path="extendOrderAnalysis"
              element={<ExtendOrderAnalysis />}
            />
            <Route
              path="studentExtendExpired"
              element={<StudentExtendExpired />}
            />
            <Route path="cancelPaymentDone" element={<CancelPaymentDone />} />
            <Route path="userActivity" element={<UserActivity />} />
            <Route path="addToCart" element={<AddToCart />} />
            <Route path="userDataSearch" element={<UserDataSearch />} />
            <Route
              path="whatsappmessageAnalysis"
              element={<WhatsappMessageAnalysis />}
            />
            <Route
              path="WhatsappDataAnalysis"
              element={<WhatsappDataAnalysis />}
            />
            <Route
              path="WhatsappDataStateAnalysis"
              element={<WhatsappDataStateAnalysis />}
            />
            <Route path="couponTypeAnalysis" element={<CouponTypeAnalysis />} />
            <Route path="addOnAnlaysis" element={<AddOnAnalysis />} />
            <Route
              path="crossSellingAnalysis"
              element={<CrossSellingAnalysis />}
            />

            <Route path="cancelledAnalysis" element={<CancelledAnalysis />} />
            <Route path="videoDownloaded" element={<VideoDownloaded />} />
            <Route path="allStudentResult" element={<AllStudentResult />} />
            <Route path="studentType2" element={<StudentType2 />} />
            <Route path="studentType3" element={<StudentType3 />} />
            <Route path="spinTheWheel" element={<SpinTheWheel />} />
            <Route path="birthDayList" element={<BirthDayList />} />
            <Route path="birthDayAnalysis" element={<BirthDayAnalysis />} />
            <Route
              path="sourceWiseDataAnalysis"
              element={<SourceWiseDataAnalysis />}
            />
            <Route
              path="sourceWiseConversionAnalysis"
              element={<SourceWiseConversionAnalysis />}
            />
            <Route path="paidPageAnalysis" element={<PaidPageAnalysis />} />
            <Route path="paidAdsAnalysis" element={<PaidAdsAnalysis />} />
            <Route path="demoGraphicData" element={<DemoGraphicsData />} />
            <Route
              path="categoryWiseAnalysis"
              element={<CategoryWiseAnalysis />}
            />
            <Route path="storyAnalysis" element={<StoryAnalysis />} />
            <Route path="freePageAnalysis" element={<FreePageAnalysis />} />

            <Route path="studentDetails" element={<StudentDetails />} />
            <Route
              path="sourceWiseLeadAnalysis"
              element={<SourceWiseLeadAnalysis />}
            />
            <Route
              path="userActivityTracker"
              element={<UserActivityTracker />}
            />
            <Route
              path="userActivityDetails"
              element={<UserActivityDetails />}
            />
            <Route
              path="ClassroomRegistrationAnalysis"
              element={<ClassroomRegistrationAnalysis />}
            />
            <Route path="PaymentDone" element={<PaymentDone />} />
            <Route path="UpcomingPayment" element={<UpcomingPayment />} />
            <Route
              path="pushNotificationAnalysis"
              element={<EditDeleteCampaign />}
            />
            <Route
              path="teacherWiseAnalysis"
              element={<TeacherWiseAnalysis />}
            />
            <Route
              path="mailCampaignAnalysis"
              element={<EditDeleteEmailCamp />}
            />
            <Route path="cxoRefundPayment" element={<RefundPayment />} />
            <Route path="FunnelAnalysis" element={<FunnelAnalysis />} />
            <Route path="Chat" element={<Chat />} />
            <Route path="chatAnalysis" element={<ChatAnalysis />} />
            <Route path="sevenDayFreeTask" element={<SevenDayFreeTask />} />
            <Route
              path="originalSourceAnalysis"
              element={<OriginalSourceAnalysis />}
            />
            <Route path="examAnalytics" element={<ExamAnalytics />} />
            <Route
              path="subscriptionAnalysis"
              element={<SubscriptionAnalysis />}
            />
            <Route
              path="campaignAnalysis"
              element={<CampaignAnalyticsModern />}
            />
            <Route
              path="orderBreakdownbySegment"
              element={<OrderBreakdownbySegment />}
            />
            <Route
              path="targetingExamAnalysis"
              element={<TargetingExamAnalysis />}
            />
            <Route path="bookSalesAnalysis" element={<BookSalesAnalysis />} />
            <Route path="leadOrderSearch" element={<LeadOrderSearch />} />

            {/* Daily Meeting tab (cxoBatchwiseCount, datewisecount and getInfluencer are routed above) */}
            <Route path="dailyLeadAnalysis" element={<DailyLeadAnalysis />} />
            <Route
              path="teacherPerformanceCat"
              element={<TeacherPerformanceCat />}
            />
            <Route
              path="offTopicPerformance"
              element={<OffTopicPerformance />}
            />
            <Route
              path="editLiveCompetitorAnalysis"
              element={<EditLiveCompetitorAnalysis />}
            />
            <Route
              path="editOffVideoCompetitorAnalysis"
              element={<EditOffVideoCompetitorAnalysis />}
            />
            <Route path="instaReels" element={<InstaReels />} />
            <Route
              path="dailyRevenueAnalysis"
              element={<DailyRevenueAnalysis />}
            />
            <Route
              path="userActivityAnalysis"
              element={<UserActivityAnalysis />}
            />
            <Route
              path="dailyPaidAdsAnalysis"
              element={<DailyPaidAdsAnalysis />}
            />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default CXOPanelDashboard;
